import React, { useState, useEffect } from 'react'
import Admin from "./Admin"

export default function AdminMatchStats({ addToast }) {
    const [stats, setStats] = useState([]);
    const [showModal, setShowModal] = useState(false);

    //SELECTHEZ
    const [selectMatches, setSelectMatches] = useState([]);
    const [selectStatIds, setSelectStatIds] = useState([]);

    //SZÜKSÉGES ADATOK AZ ADATBAZISBA
    const [matchId, setMatchId] = useState(null);
    const [statId, setStatId] = useState(null);
    const [homeData, setHomeData] = useState(null);
    const [awayData, setAwayData] = useState(null);



    // Mérkőzések lekérése modal select-be
    useEffect(() => {
        fetch("https://focifanatik.hu/api/adminMatchStatsSelect.php")
            .then((response) => response.json())
            .then((data) => {
                console.log("Kapott adatok:", data);
                setSelectMatches(data);
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);


    // StatId-k lekérése modal select-be
    useEffect(() => {
        fetch("https://focifanatik.hu/api/adminMatchStatsSelectStatId.php")
            .then((response) => response.json())
            .then((data) => {
                console.log("Kapott adatok:", data);
                setSelectStatIds(data);
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);



    const handleSave = () => {
        fetch("https://focifanatik.hu/api/admin_add_match_statistics.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                match_id: matchId,
                stat_id: statId,
                home_value: homeData,
                away_value: awayData
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    addToast("Statisztika hozzáadva!", "success");
                    setShowModal(false);
                    fetch("https://focifanatik.hu/api/admin_match_statistics.php")
                        .then(res => res.json())
                        .then(data => setStats(data))
                        .catch(err => console.error("Fetch hiba:", err));
                } else {
                    addToast(data.error || "Hiba!", "warning");
                }
            })
            .catch(() => addToast("Hálózati hiba!", "danger"));
    };


    useEffect(() => {
        // FONTOS: pontos URL
        fetch("https://focifanatik.hu/api/admin_match_statistics.php")
            .then((response) => response.json())
            .then((data) => {
                console.log("Kapott adatok:", data); // ← ezzel látod a böngésző konzolban, hogy tényleg jön adat
                setStats(data);
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);

    //STATISZTIKÁK TÖRLÉSE
    const handleDelete = (id) => {
        if (!window.confirm("Biztosan törölni szeretnéd ezt a statisztikát?")) return;

        fetch(`https://focifanatik.hu/api/admin_delete_match_statistics.php?id=${id}`, {
            method: "DELETE",
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    addToast("Sikeres törlés!", "success")
                    // újratöltjük a listát
                    setStats(stats.filter(team => team.id !== id));
                } else {
                    addToast("Hiba!", "warning")
                }
            })
            .catch(err => console.error("Hálózati hiba:", err));
    };


    const handleCloseModal = () => {
        setShowModal(false)
    };

    return (
        <div className="admin-page">
            <Admin />
            <main className="admin-content">
                <header className="admin-header">
                    <h3>🏆 Statisztikák kezelése</h3>
                </header>

                <section className="admin-main">
                    <p className="text-muted">Itt tudod kezelni a statisztikákat.</p>

                    <button
                        className="btn btn-success mb-3"
                        onClick={() => {
                            // kiürítjük a mezőket és megnyitjuk az üres modalt
                            setStatId(null);
                            setHomeData(null);
                            setAwayData(null);
                            setShowModal(true);
                        }}
                    >
                        <i className="bi bi-plus-circle"></i> Új statisztika hozzáadása
                    </button>

                    <div className="table-responsive mt-4">
                        <table className="table table-striped text-center align-middle">
                            <thead className="table-success">
                                <tr>
                                    <th>ID</th>
                                    <th>MatchId</th>
                                    <th>StatId(Key)</th>
                                    <th>Home Data</th>
                                    <th>Away Data</th>
                                    <th>Műveletek</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stats.map((s) =>
                                    <tr key={s.id}>
                                        <td>{s.id}</td>
                                        <td>{s.match_id}</td>
                                        <td>{s.stat_key}</td>
                                        <td>{s.home_value}</td>
                                        <td>{s.away_value}</td>
                                        <td>
                                            <div className="d-flex justify-content-center gap-2">
                                                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(s.id)}>
                                                    <i className="bi bi-trash"></i> Törlés
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </section>
            </main>

            {showModal && (
                <>
                    {/* Sötét háttér */}
                    <div className="custom-modal-backdrop"></div>

                    <div className="custom-modal d-flex justify-content-center align-items-center">
                        <div className="custom-modal-content">

                            {/* CÍM */}
                            <div className="custom-modal-header">
                                <h5 className="modal-title-custom">
                                    Új statisztika létrehozása
                                </h5>
                                <button className="close-btn" onClick={handleCloseModal}>×</button>
                            </div>


                            {/* TARTALOM */}
                            <div className="custom-modal-body">
                                <form>
                                    <div className="mb-3">
                                        <label className="form-label">Match ID</label>

                                        <select
                                            className="form-select"
                                            value={matchId}
                                            onChange={(e) => setMatchId(e.target.value)}>
                                            <option value="">-- Válassz mérkőzést --</option>
                                            {selectMatches.map((m) =>
                                                <option key={m.id} value={m.id}>{m.id} - {m.homeName} vs {m.awayName}</option>
                                            )}
                                        </select>

                                    </div>


                                    <div className="mb-3">
                                        <label className="form-label">Stat ID</label>
                                        <select
                                            className="form-select"
                                            value={statId}
                                            onChange={(e) => setStatId(e.target.value)}>
                                            <option value="">-- Válassz statot --</option>
                                            {selectStatIds.map((s) =>
                                                <option key={s.id} value={s.id}>{s.id} - {s.stat_key} - {s.card_type}</option>
                                            )}
                                        </select>

                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Home Data</label>
                                        <input
                                            type='text'
                                            // step="0.01"
                                            className="form-control"
                                            value={homeData}
                                            onChange={(e) => setHomeData(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Away Data</label>
                                        <input
                                            type="text"
                                            // step="0.01"
                                            className="form-control"
                                            value={awayData}
                                            onChange={(e) => setAwayData(e.target.value)}
                                        />
                                    </div>


                                </form>
                            </div>

                            {/* LÁB */}
                            <div className="custom-modal-footer">
                                <button className="pretty-btn cancel-btn" onClick={handleCloseModal}>
                                    Mégse
                                </button>
                                <button className="pretty-btn save-btn" onClick={handleSave}>
                                    Mentés
                                </button>
                            </div>


                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
